// extracted by mini-css-extract-plugin
module.exports = {"rowField":"substitution-form_rowField__2ViJx","ul":"substitution-form_ul__2kjWH"};